/* Product page gallery: one square stage showing the selected variant's UNLIT
   photo (the same shot as its collections-hub card). product-options.js rebuilds
   it when the scent or size changes. The thumbnail strip is kept in the markup
   but hidden by CSS: only one image per variant is shown. */
(function () {
  function init() {
    var gallery = document.querySelector('.js-product-gallery');
    if (!gallery) return;
    var stage = gallery.querySelector('.js-stage');
    var thumbs = gallery.querySelector('.js-thumbs');
    if (!stage || !thumbs) return;

    function activate(btn) {
      if (!btn) return;
      thumbs.querySelectorAll('.product__thumb-btn').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
      var full = btn.getAttribute('data-full');
      if (full && stage.getAttribute('src') !== full) {
        stage.removeAttribute('srcset');
        stage.src = full;
      }
      stage.alt = btn.getAttribute('data-alt') || '';
    }

    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('.product__thumb-btn');
      if (btn) activate(btn);
    });

    function makeThumb(url, alt) {
      var li = document.createElement('li');
      li.className = 'product__thumb js-variant-thumb';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product__thumb-btn';
      btn.setAttribute('data-full', url);
      btn.setAttribute('data-alt', alt || '');
      var img = document.createElement('img');
      img.src = url;
      img.alt = alt || '';
      img.width = 80;
      img.height = 80;
      btn.appendChild(img);
      li.appendChild(btn);
      return li;
    }

    window.rwProductGallery = {
      // Show the variant's unlit photo on the stage (lit only when no unlit exists).
      setVariantImages: function (unlit, lit, alt) {
        thumbs.querySelectorAll('.js-variant-thumb').forEach(function (li) { li.remove(); });
        var urls = [];
        if (unlit) urls.push(unlit);
        else if (lit) urls.push(lit);
        var anchor = thumbs.firstChild;
        urls.forEach(function (u) {
          thumbs.insertBefore(makeThumb(u, alt), anchor);
        });
        activate(thumbs.querySelector('.product__thumb-btn'));
      },
      show: activate
    };
  }

  // The scent switcher calls this again after swapping in a sibling scent.
  window.rwInitProductGallery = init;
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
